{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Színválasztó",
  "colorSwatch": "színtár",
  "transparent": "átlátszó",
  "twoDimensionalSlider": "2D-csúszka"
}
